<h1 class="visually-hidden">Design Your Box (Beta)</h1>
<div class="design-2d-header">
  <div class="toolbar-tools">
    <div class="toolbar-title">DESIGN</div>
    <div
      class="toolbar-tools-group"
      [class.tour-highlight]="helpSection === 'toolbarExplanation'"
      [popover]="toolbarExplanationContent"
      [isOpen]="helpSection === 'toolbarExplanation'"
      placement="bottom"
      container="body"
      triggers=""
    >
      <button
        type="button"
        class="toolbar-button"
        (click)="duplicateSelected()"
        [disabled]="!selectedElementType || selectedElementType === 'pattern'"
      >
        <i class="fa-sharp fa-light fa-copy"></i>
        <span class="label">Duplicate</span>
      </button>
      <button
        type="button"
        class="toolbar-button"
        (click)="moveBackward()"
        [disabled]="!selectedElementType || selectedElementType === 'pattern'"
      >
        <i class="fa-sharp fa-light fa-angle-left"></i>
        <span class="label">Move Backward</span>
      </button>
      <button
        type="button"
        class="toolbar-button"
        (click)="moveForward()"
        [disabled]="!selectedElementType || selectedElementType === 'pattern'"
      >
        <i class="fa-sharp fa-light fa-angle-right"></i>
        <span class="label">Move Forward</span>
      </button>
      <button type="button" class="toolbar-button" (click)="undo()" [disabled]="!canUndo">
        <i class="fa-sharp fa-light fa-rotate-left"></i>
        <span class="label">Undo</span>
      </button>
      <button type="button" class="toolbar-button" (click)="redo()" [disabled]="!canRedo">
        <i class="fa-sharp fa-light fa-rotate-right"></i>
        <span class="label">Redo</span>
      </button>
      <button type="button" class="toolbar-button" (click)="confirmClearAll()">
        <i class="fa-sharp fa-light fa-x"></i>
        <span class="label">Clear All</span>
      </button>
      <button type="button" class="toolbar-button" (click)="deleteSelected()" [disabled]="!selectedElementType">
        <i class="fa-sharp fa-light fa-trash-can"></i>
        <span class="label">Delete</span>
      </button>
      <button type="button" class="toolbar-button" (click)="requestSave()" [disabled]="saving">
        <i class="fa-sharp fa-light fa-save"></i>
        <span class="label">Save</span>
      </button>
    </div>
    <button
      type="button"
      class="add-to-cart-button"
      [class.tour-highlight]="helpSection === 'addToCartExplanation'"
      [disabled]="addingToCart"
      [popover]="addToCartExplanationContent"
      [isOpen]="helpSection === 'addToCartExplanation'"
      placement="left"
      container="body"
      triggers=""
      (click)="requestAddToCart()"
    >
      <i class="fas fa-cart-shopping"></i>
      <span>ADD<span class="d-none d-lg-inline"> TO CART</span></span>
    </button>
  </div>
</div>

<div class="design-2d-workspace">
  <div class="design-2d-sidebar">
    <div
      class="sidebar-categories"
      [class.tour-highlight]="helpSection === 'elementExplanation'"
      [popover]="elementExplanationContent"
      [isOpen]="helpSection === 'elementExplanation'"
      placement="right"
      container="body"
      triggers=""
    >
      @if (aiDesignChatEnabled) {
        <button
          type="button"
          class="sidebar-category"
          [class.sidebar-category--active]="activeCategory === 'ai'"
          [disabled]="loading || !valid"
          (click)="toggleCategory('ai')"
        >
          <i class="fa-sharp fa-light fa-sparkles"></i>
          <span>AI Design</span>
        </button>
      }
      <button
        type="button"
        class="sidebar-category"
        [class.sidebar-category--active]="activeCategory === 'draw'"
        [disabled]="loading || !valid"
        (click)="toggleCategory('draw')"
      >
        <i class="fa-sharp fa-light fa-paintbrush-pencil"></i>
        <span>Draw<br />&amp; Fill</span>
      </button>
      <button
        type="button"
        class="sidebar-category"
        [class.sidebar-category--active]="activeCategory === 'patterns'"
        [disabled]="loading || !valid"
        (click)="toggleCategory('patterns')"
      >
        <i class="fa-sharp fa-light fa-diamonds-4" style="transform: rotate(45deg)"></i>
        <span>Patterns</span>
      </button>
      <button
        type="button"
        class="sidebar-category"
        [class.sidebar-category--active]="activeCategory === 'shapes'"
        [disabled]="loading || !valid"
        (click)="toggleCategory('shapes')"
      >
        <i class="fa-sharp fa-light fa-shapes"></i>
        <span>Shapes</span>
      </button>
      <button
        type="button"
        class="sidebar-category"
        [class.sidebar-category--active]="activeCategory === 'images'"
        [disabled]="loading || !valid"
        (click)="toggleCategory('images')"
      >
        <i class="fa-sharp fa-light fa-image"></i>
        <span>Images</span>
      </button>
      <button type="button" class="sidebar-category" [disabled]="loading || !valid" (click)="addText()">
        <i class="fa-sharp fa-light fa-t"></i>
        <span>Text</span>
      </button>
      <button
        type="button"
        class="sidebar-category"
        [class.sidebar-category--active]="activeCategory === 'material'"
        [disabled]="loading || !valid"
        (click)="toggleCategory('material')"
      >
        <i class="fa-sharp fa-light fa-layer-group"></i>
        <span>Material<br />&amp; Finish</span>
      </button>
    </div>

    <div class="sidebar-help">
      <button type="button" class="sidebar-category" (click)="openTutorial()">
        <i class="fa-sharp fa-light fa-circle-play"></i>
        <span>Tutorial</span>
      </button>
      <button type="button" class="sidebar-category" (click)="showHelpSection('elementExplanation')">
        <i class="fa-sharp fa-light fa-street-view"></i>
        <span>Guided Tour</span>
      </button>
    </div>
  </div>

  <div class="design-2d-content">
    <ng-template #legendPopoverContent>
      <div class="legend-popover-header">
        <span>Legend</span>
        <button type="button" class="legend-popover-close" aria-label="Close legend" (click)="legendPopover.hide()">
          <i class="fa-sharp fa-light fa-xmark"></i>
        </button>
      </div>
      <div class="legend-modal-list">
        <div class="legend-modal-item">
          <span class="legend-swatch legend-swatch--bleed"></span>
          <div class="legend-modal-text">
            <b>Bleed</b>
            <p>
              "Bleed" is the portion of a printed design that extends beyond the trim area to prevent unprinted edges
              after cutting.
            </p>
          </div>
        </div>
        <div class="legend-modal-item">
          <span class="legend-swatch legend-swatch--crease"></span>
          <div class="legend-modal-text">
            <b>Crease</b>
            <p>
              The "crease" refers to a line or fold made in the paper to facilitate bending or folding without damaging
              the material.
            </p>
          </div>
        </div>
        <div class="legend-modal-item">
          <span class="legend-swatch legend-swatch--cut"></span>
          <div class="legend-modal-text">
            <b>Cut</b>
            <p>
              A "cut" line indicates where the material should be trimmed to achieve the final size of the printed
              piece.
            </p>
          </div>
        </div>
      </div>
    </ng-template>

    <div class="design-2d-content-row" #contentRow>
      <div class="design-2d-content-row-track" [class.design-2d-content-row-track--open]="activeCategory">
        <div
          class="design-2d-flyout"
          [class.design-2d-flyout--open]="activeCategory"
          [class.tour-highlight]="helpSection === 'patternExplanation'"
          [popover]="patternExplanationContent"
          [isOpen]="helpSection === 'patternExplanation'"
          placement="right"
          container="body"
          triggers=""
        >
          @if (activeCategory) {
            <div class="flyout-header">
              <h2 class="flyout-header--with-help">
                {{ categoryLabel }}
                <button type="button" class="design-3d-help-link" (click)="showCategoryHelp()">
                  <i class="fa-sharp fa-light fa-circle-question"></i>
                  <span>Help</span>
                </button>
              </h2>
            </div>
            <div class="flyout-body" [class.flyout-body--unclipped]="activeCategory === 'draw'">
              @switch (activeCategory) {
                @case ("ai") {
                  <app-ai-design-chat
                    [messages]="aiDecalMessages"
                    [isGenerating]="aiDecalGenerating"
                    (promptSubmitted)="onAiDecalPromptSubmitted($event)"
                    (cleared)="clearAiDecalChat()"
                  ></app-ai-design-chat>
                }
                @case ("shapes") {
                  <div class="shape-container" #shapeContainerEl>
                    @if (!shapeCollections.length) {
                      <p class="flyout-placeholder">Loading shapes&hellip;</p>
                    }
                    @for (collection of shapeCollections; track trackByFn($index, collection)) {
                      <div>
                        <h3 class="shape-collection-title">{{ collection.name | uppercase }}</h3>
                        <div class="shape-list">
                          @for (shape of getCollectionShapes(collection.id); track trackByFn($index, shape)) {
                            <button
                              type="button"
                              class="shape-thumbnail-button"
                              (click)="addShape(shape)"
                              [attr.aria-label]="'Add shape ' + shape.name"
                            >
                              <app-canvas-shape [shape]="shape" location="menu"></app-canvas-shape>
                            </button>
                          }
                        </div>
                      </div>
                    }
                    <div
                      [scrollContainer]="shapeContainerEl"
                      (nearBottom)="loadMoreShapes()"
                      appInfiniteScrollSentinel
                    ></div>
                  </div>
                  @if (shapeCollections.length) {
                    <button type="button" class="flyout-library-button" (click)="openShapeLibrary()">
                      View Entire Library
                    </button>
                  }
                }
                @case ("images") {
                  <div class="image-tool-buttons">
                    <button type="button" class="tool-btn" (click)="openImageModal(uploadImage)">
                      <i class="fa fa-image fa-2x mb-2"></i>
                      <span>Upload Image</span>
                    </button>
                    <button type="button" class="tool-btn" (click)="openImageModal(uploadPixabay)">
                      <i class="fa-kit fa-pixabay-camera fa-2x mb-2"></i>
                      <span>Add Pixabay</span>
                    </button>
                    @if (aiImageGenerationEnabled) {
                      <button type="button" class="tool-btn" (click)="openImageModal(aiImageGenerate)">
                        <i class="fa fa-sparkles fa-2x mb-2"></i>
                        <span>AI Generate</span>
                      </button>
                    }
                  </div>
                  @if (images.length) {
                    <h3 class="shape-collection-title">YOUR UPLOADED IMAGES</h3>
                    <div class="shape-list">
                      @for (image of images; track trackByFn($index, image)) {
                        <button
                          type="button"
                          class="shape-thumbnail-button"
                          (click)="addImage(image)"
                          [style.backgroundImage]="'url(&quot;' + image.src + '&quot;)'"
                          [attr.aria-label]="'Add uploaded image to design: ' + image.name"
                          [matTooltip]="image.name"
                          matTooltipPosition="above"
                          matTooltipClass="design-3d-tooltip"
                        ></button>
                      }
                    </div>
                  }
                }
                @case ("patterns") {
                  <div class="element-toolbar-btn-group pattern-tab-group">
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      [class.active]="patternTabMode === 'library'"
                      (click)="setPatternTabMode('library')"
                    >
                      Library
                    </button>
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      [class.active]="patternTabMode === 'custom'"
                      (click)="setPatternTabMode('custom')"
                    >
                      Custom
                    </button>
                  </div>
                  @if (patternTabMode === "library") {
                    <div class="shape-container" #patternContainerEl>
                      @if (!patternCollections.length) {
                        <p class="flyout-placeholder">Loading patterns&hellip;</p>
                      }
                      @for (collection of patternCollections; track trackByFn($index, collection)) {
                        <div>
                          <h3 class="shape-collection-title">{{ collection.name | uppercase }}</h3>
                          <div class="shape-list">
                            @for (pattern of getCollectionPatterns(collection.id); track trackByFn($index, pattern)) {
                              <button
                                type="button"
                                class="shape-thumbnail-button"
                                (click)="addPattern(pattern)"
                                [style.backgroundImage]="'url(&quot;' + pattern.srcUrl + '&quot;)'"
                                [attr.aria-label]="'Add pattern ' + pattern.name"
                              ></button>
                            }
                          </div>
                        </div>
                      }
                      <div
                        [scrollContainer]="patternContainerEl"
                        (nearBottom)="loadMorePatterns()"
                        appInfiniteScrollSentinel
                      ></div>
                    </div>
                    @if (patternCollections.length) {
                      <button type="button" class="flyout-library-button" (click)="openPatternLibrary()">
                        View Entire Library
                      </button>
                    }
                  } @else {
                    <div class="element-toolbar-group">
                      <button type="button" class="flyout-library-button" (click)="addGeometricPatternWholeBox()">Add to Whole Box</button>
                      <button
                        type="button"
                        class="flyout-library-button"
                        [class.active]="geometricPatternToolActive"
                        (click)="toggleGeometricPatternTool()"
                      >
                        {{ geometricPatternToolActive ? "Click a Panel…" : "Add to a Panel" }}
                      </button>
                    </div>
                  }
                }
                @case ("material") {
                  @if (printingOptions.length) {
                    <h3 class="box-details-title">{{ boxDetailsTitle }}</h3>
                    <div class="box-details">
                      @if (!isPaddedMailer) {
                        <p [innerHTML]="boxDetailsCategoryName"></p>
                      }
                      @if (boxDetailsSizeLabel) {
                        <p>{{ boxDetailsSizeLabel }}</p>
                      }
                    </div>
                    <form class="material-finish-form">
                      <div class="form-group">
                        <mat-label>Printing</mat-label><br />
                        <mat-select
                          name="printing"
                          aria-label="Printing"
                          disableOptionCentering="true"
                          [(ngModel)]="printing"
                        >
                          @for (option of printingOptions; track option) {
                            <mat-option (click)="printingSelected(option)" [value]="option">{{ option }}</mat-option>
                          }
                        </mat-select>
                      </div>
                      @if (showOuterMaterialSelect) {
                        <div class="form-group">
                          <mat-label>{{ isPaddedMailer ? "Material" : "Outer Material" }}</mat-label
                          ><br />
                          <mat-select
                            name="outerMaterial"
                            [attr.aria-label]="isPaddedMailer ? 'Material' : 'Outer Material'"
                            disableOptionCentering="true"
                            [(ngModel)]="outerMaterial"
                            (selectionChange)="onMaterialFinishChanged()"
                          >
                            @for (option of outerMaterialOptions; track option) {
                              <mat-option [value]="option">{{ option }}</mat-option>
                            }
                          </mat-select>
                        </div>
                      }
                      @if (showInnerAndFinishSelects) {
                        <div class="form-group">
                          <mat-label>Inner Material</mat-label><br />
                          <mat-select
                            name="innerMaterial"
                            aria-label="Inner Material"
                            disableOptionCentering="true"
                            [(ngModel)]="innerMaterial"
                            (selectionChange)="onMaterialFinishChanged()"
                          >
                            @for (option of innerMaterialOptions; track option) {
                              <mat-option [value]="option">{{ option }}</mat-option>
                            }
                          </mat-select>
                        </div>
                        <div class="form-group">
                          <mat-label>Finish</mat-label><br />
                          <mat-select
                            name="finish"
                            aria-label="Finish"
                            disableOptionCentering="true"
                            [(ngModel)]="finish"
                          >
                            @for (option of finishOptions; track option) {
                              <mat-option [value]="option">{{ option }}</mat-option>
                            }
                          </mat-select>
                        </div>
                      }
                    </form>
                  } @else {
                    <p class="flyout-placeholder">Loading material &amp; finish options&hellip;</p>
                  }
                }
                @case ("draw") {
                  <div class="element-toolbar-group">
                    <span class="element-toolbar-label">Tool</span>
                    <div class="element-toolbar-btn-group">
                      <button
                        type="button"
                        class="element-toolbar-btn element-toolbar-btn--lg"
                        [class.active]="canvasTool === 'draw' && brushType === 'pencil'"
                        (click)="selectBrushType('pencil')"
                        aria-label="Pencil brush"
                        matTooltip="Pencil"
                        matTooltipPosition="above"
                        matTooltipClass="design-3d-tooltip"
                      >
                        <i class="fa-sharp fa-light fa-pencil"></i>
                      </button>
                      <button
                        type="button"
                        class="element-toolbar-btn element-toolbar-btn--lg"
                        [class.active]="canvasTool === 'draw' && brushType === 'circle'"
                        (click)="selectBrushType('circle')"
                        aria-label="Marker brush"
                        matTooltip="Marker"
                        matTooltipPosition="above"
                        matTooltipClass="design-3d-tooltip"
                      >
                        <i class="fa-sharp fa-light fa-marker"></i>
                      </button>
                      <button
                        type="button"
                        class="element-toolbar-btn element-toolbar-btn--lg"
                        [class.active]="canvasTool === 'draw' && brushType === 'spray'"
                        (click)="selectBrushType('spray')"
                        aria-label="Spray brush"
                        matTooltip="Spray"
                        matTooltipPosition="above"
                        matTooltipClass="design-3d-tooltip"
                      >
                        <i class="fa-sharp fa-light fa-spray-can"></i>
                      </button>
                      <button
                        type="button"
                        class="element-toolbar-btn element-toolbar-btn--lg"
                        [class.active]="fillToolActive"
                        (click)="toggleFillTool()"
                        aria-label="Fill"
                        matTooltip="Fill"
                        matTooltipPosition="above"
                        matTooltipClass="design-3d-tooltip"
                      >
                        <i class="fa-sharp fa-light fa-fill-drip"></i>
                      </button>
                    </div>
                  </div>
                  @if (fillToolActive) {
                    <app-gradient-picker
                      [value]="pendingFillValue"
                      ariaLabel="Fill color"
                      [showColorFields]="false"
                      [showAngle]="false"
                      (valueChange)="setFillValue($event)"
                    />
                  } @else {
                    <div class="element-toolbar-group">
                      <span class="element-toolbar-label">Color</span>
                      <app-color-picker
                        [hex]="brushColor"
                        [cmyk]="brushColorCmyk"
                        ariaLabel="Brush color"
                        (colorChange)="setBrushColor($event)"
                      />
                    </div>
                  }
                  @if (!fillToolActive) {
                    <div class="element-toolbar-group">
                      <span class="element-toolbar-label">Width</span>
                      <mat-slider
                        class="design-3d-slider"
                        discrete
                        min="1"
                        max="50"
                        step="1"
                        matTooltip="Brush width"
                        matTooltipPosition="above"
                        matTooltipClass="design-3d-tooltip"
                      >
                        <input
                          matSliderThumb
                          aria-label="Brush width"
                          [ngModel]="brushWidth"
                          (ngModelChange)="setBrushWidth($event)"
                          (pointerup)="blurSliderThumb($event)"
                        />
                      </mat-slider>
                    </div>
                  }
                }
              }
            </div>
            <div class="flyout-footer">
              <button type="button" class="flyout-close" (click)="toggleCategory(activeCategory)">Collapse</button>
            </div>
          }
        </div>

        <div class="design-2d-panels">
        <div
          class="design-2d-canvas-block"
          [class.design-2d-canvas-block--dragging]="isDraggingDivider"
          [class.fill-tool-active]="fillToolActive"
          [style.flex-basis.cqw]="splitRatio"
          [style.cursor]="fillToolActive ? fillToolCursor : null"
        >
          <div class="design-2d-legend">
            <div class="legend-key">
              <span class="legend-item"><span class="legend-swatch legend-swatch--bleed"></span>Bleed</span>
              <span class="legend-item"><span class="legend-swatch legend-swatch--crease"></span>Crease</span>
              <span class="legend-item"><span class="legend-swatch legend-swatch--cut"></span>Cut</span>
            </div>
            <div class="legend-actions">
              <button
                type="button"
                class="legend-button"
                #legendPopover="bs-popover"
                [popover]="legendPopoverContent"
                placement="bottom"
                container="body"
                containerClass="key-popover me-3"
                triggers="click"
                [outsideClick]="true"
              >
                <i class="fa-sharp fa-light fa-circle-info me-1"></i>
                <span>Legend</span>
              </button>
              <button type="button" class="design-3d-help-link" (click)="showDesignAreaHelp()">
                <i class="fa-sharp fa-light fa-circle-question"></i>
                <span>Help</span>
              </button>
            </div>
          </div>

          <div class="design-2d-canvas-column" #canvasColumn>
            <div
              #cornerGroupLeft
              class="canvas-corner-group canvas-corner-group--left"
              [class.tour-highlight]="helpSection === 'rulerExplanation'"
              [popover]="rulerExplanationContent"
              [isOpen]="helpSection === 'rulerExplanation'"
              placement="right"
              container="body"
              triggers=""
            >
              <button
                type="button"
                class="canvas-corner-button canvas-corner-button--rulers"
                [class.active]="showRulers"
                (click)="toggleRulers()"
                aria-label="Toggle rulers"
                matTooltip="Rulers"
                matTooltipPosition="above"
                matTooltipClass="design-3d-tooltip"
              >
                <i class="fa-sharp fa-light fa-ruler-combined fa-rotate-90"></i>
              </button>
              <button
                type="button"
                class="canvas-corner-button canvas-corner-button--guides"
                [class.active]="showGridlines"
                (click)="toggleGridlines()"
                [attr.aria-label]="(showGridlines ? 'Hide' : 'Show') + ' guides'"
                [matTooltip]="(showGridlines ? 'Hide' : 'Show') + ' Guides'"
                matTooltipPosition="above"
                matTooltipClass="design-3d-tooltip"
              >
                <i class="fa-sharp fa-light fa-border-all"></i>
              </button>
            </div>
            <div
              #cornerGroupRight
              class="canvas-corner-group canvas-corner-group--right"
              [class.tour-highlight]="helpSection === 'zoomExplanation'"
              [popover]="zoomExplanationContent"
              [isOpen]="helpSection === 'zoomExplanation'"
              placement="left"
              container="body"
              triggers=""
            >
              @if (canvas2dZoom !== 1) {
                <button
                  type="button"
                  class="canvas-corner-button canvas-corner-button--zoom-reset"
                  (click)="resetZoom()"
                  aria-label="Reset zoom"
                  matTooltip="Reset Zoom"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <i class="fa-sharp fa-light fa-expand"></i>
                </button>
              }
              <button
                type="button"
                class="canvas-corner-button canvas-corner-button--zoom-out"
                [disabled]="!canZoomOut"
                (click)="zoomOut()"
                aria-label="Zoom out"
                matTooltip="Zoom Out"
                matTooltipPosition="above"
                matTooltipClass="design-3d-tooltip"
              >
                <i class="fa-sharp fa-light fa-search-minus"></i>
              </button>
              <button
                type="button"
                class="canvas-corner-button canvas-corner-button--zoom-in"
                [disabled]="!canZoomIn"
                (click)="zoomIn()"
                aria-label="Zoom in"
                matTooltip="Zoom In"
                matTooltipPosition="above"
                matTooltipClass="design-3d-tooltip"
              >
                <i class="fa-sharp fa-light fa-search-plus"></i>
              </button>
            </div>
            @if (canvas2dZoom > 1) {
              <div #cornerGroupBottom class="canvas-corner-group canvas-corner-group--bottom">
                <button
                  type="button"
                  class="canvas-corner-button canvas-corner-button--select-tool"
                  [class.active]="canvasTool === 'select'"
                  (click)="setCanvasTool('select')"
                  aria-label="Select tool"
                  matTooltip="Select elements"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <i class="fa-sharp fa-light fa-mouse-pointer"></i>
                </button>
                <button
                  type="button"
                  class="canvas-corner-button canvas-corner-button--move-tool"
                  [class.active]="canvasTool === 'move'"
                  (click)="setCanvasTool('move')"
                  aria-label="Move tool"
                  matTooltip="Move the zoomed area around"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <i class="fa-sharp fa-light fa-hand-paper"></i>
                </button>
              </div>
            }
            <div
              class="design-2d-ruler-grid"
              [class.design-2d-ruler-grid--no-rulers]="!showRulers"
              [class.tour-highlight]="helpSection === 'designAreaExplanation'"
              [popover]="designAreaExplanationContent"
              [isOpen]="helpSection === 'designAreaExplanation'"
              placement="right"
              container="body"
              triggers=""
              [style.width.px]="rulerGridWidthPx"
              [style.height.px]="rulerGridHeightPx"
              [style.gridTemplateColumns]="rulerThicknessPx + 'px 1fr'"
              [style.gridTemplateRows]="rulerThicknessPx + 'px 1fr'"
              [style.transform]="'scale(' + canvas2dFitScale + ')'"
            >
              @if (showRulers) {
                <div class="ruler-corner"></div>
                <div class="ruler-x" [style.width.px]="rulerGridWidthPx - rulerThicknessPx">
                  <div #rulerXTicks class="ruler-ticks-x">
                    @for (tick of rulerTicksX; track tick.pos) {
                      <span
                        class="ruler-tick ruler-tick--x ruler-tick--{{ tick.size }}"
                        [style.left.px]="tick.pos * canvas2dZoom + canvas2dCenterOffsetX"
                      >
                        @if (tick.label !== undefined) {
                          <span class="ruler-tick-label">{{ tick.label }}"</span>
                        }
                      </span>
                    }
                  </div>
                </div>
                <div class="ruler-y" [style.height.px]="rulerGridHeightPx - rulerThicknessPx">
                  <div #rulerYTicks class="ruler-ticks-y">
                    @for (tick of rulerTicksY; track tick.pos) {
                      <span
                        class="ruler-tick ruler-tick--y ruler-tick--{{ tick.size }}"
                        [style.top.px]="tick.pos * canvas2dZoom + canvas2dCenterOffsetY"
                      >
                        @if (tick.label !== undefined) {
                          <span class="ruler-tick-label">{{ tick.label }}"</span>
                        }
                      </span>
                    }
                  </div>
                </div>
                <div class="crosshair-vertical" #crosshairVertical></div>
                <div class="crosshair-horizontal" #crosshairHorizontal></div>
                <div class="crosshair-label" #crosshairLabel></div>
              }
              <div class="transform-hud" #transformHud></div>
              <svg class="panel-hover-outline" #panelHoverOutline>
                <path #panelHoverOutlinePath />
              </svg>
              <div class="panel-name-tooltip" #panelNameTooltip></div>
              <div
                class="design-2d-canvas-scroll"
                #canvasScroll
                [class.design-2d-canvas-scroll--fit]="canvas2dZoom <= 1"
                [style.--canvas2d-fit-scale]="canvas2dFitScale"
              >
                <div
                  class="design-2d-canvas-wrap"
                  [style.width.px]="canvasWidthPx + canvasMargin * 2"
                  [style.height.px]="canvasHeightPx + canvasMargin * 2"
                  [style.transform]="
                    'translate(' + canvas2dCenterOffsetX + 'px, ' + canvas2dCenterOffsetY + 'px) scale(' + canvas2dZoom + ')'
                  "
                >
                  <div class="design-2d-canvas-side" [class.design-2d-canvas-side--hidden]="activeSide !== 'outside'">
                    <canvas #canvas2dOutside></canvas>
                  </div>
                  <div class="design-2d-canvas-side" [class.design-2d-canvas-side--hidden]="activeSide !== 'inside'">
                    <canvas #canvas2dInside></canvas>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="bottom-actions">
            <div
              class="side-toggle-group"
              [class.tour-highlight]="helpSection === 'twoSidedExplanation'"
              [popover]="twoSidedExplanationContent"
              [isOpen]="helpSection === 'twoSidedExplanation'"
              placement="top"
              container="body"
              triggers=""
            >
              <div class="side-toggle">
                <span class="side-toggle-label">Showing:</span>
                <div class="side-toggle-buttons">
                  @if (twoSided) {
                    <button
                      type="button"
                      class="side-toggle-button"
                      [class.active]="activeSide === 'outside'"
                      [attr.aria-pressed]="activeSide === 'outside'"
                      (click)="toggleShowingSide('outside')"
                    >
                      Outside
                    </button>
                    <button
                      type="button"
                      class="side-toggle-button"
                      [class.active]="activeSide === 'inside'"
                      [attr.aria-pressed]="activeSide === 'inside'"
                      (click)="toggleShowingSide('inside')"
                    >
                      Inside
                    </button>
                  } @else if (insideOnly) {
                    <span
                      matTooltip="Outside print not added"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <button type="button" class="side-toggle-button disabled" disabled aria-pressed="false">
                        Outside
                      </button>
                    </span>
                    <button type="button" class="side-toggle-button active" aria-pressed="true">Inside</button>
                  } @else {
                    <button type="button" class="side-toggle-button active" aria-pressed="true">Outside</button>
                    <span
                      matTooltip="Inside print not added"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <button type="button" class="side-toggle-button disabled" disabled aria-pressed="false">
                        Inside
                      </button>
                    </span>
                  }
                </div>
              </div>
            </div>
            <div class="right-actions">
              @if (twoSided) {
                <button
                  type="button"
                  class="cancel-two-sided-link"
                  matTooltip="Cancel two sided print"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                  (click)="confirmCancelTwoSidedPrinting()"
                >
                  <span>Cancel two sided print</span>
                </button>
              } @else if (displayTwoSided) {
                <button
                  type="button"
                  class="two-sided-button"
                  matTooltip="Add two-sided printing"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                  (click)="promptTwoSidedPrinting()"
                >
                  <i class="fa fa-plus"></i>
                  <span>Two-Side Printing</span>
                </button>
              }
              <button
                type="button"
                class="download-button"
                matTooltip="Download"
                matTooltipPosition="above"
                matTooltipClass="design-3d-tooltip"
                #downloadPopover="bs-popover"
                [popover]="downloadPopoverContent"
                placement="top"
                container="body"
                containerClass="download-popover"
                triggers="click"
                [outsideClick]="true"
              >
                <span class="download-button-compact-icon"><i class="fa-sharp fa-light fa-download"></i></span>
                <span class="download-button-label">Download</span>
                <span class="download-button-chevron"><i class="fa-sharp fa-light fa-chevron-down"></i></span>
              </button>
            </div>
          </div>
          <div
            class="panel-divider"
            [class.panel-divider--active]="isDraggingDivider"
            role="separator"
            aria-orientation="vertical"
            [attr.aria-valuenow]="splitRatio | number: '1.0-0'"
            [attr.aria-valuemin]="SPLIT_MIN"
            [attr.aria-valuemax]="SPLIT_MAX"
            aria-label="Resize 2D designer and 3D preview panels"
            tabindex="0"
            (pointerdown)="panelDividerTooltip.hide(); onDividerPointerDown($event)"
            (pointermove)="onDividerPointerMove($event)"
            (pointerup)="onDividerPointerUp($event)"
            (keydown)="onDividerKeydown($event)"
          >
            <span
              class="panel-divider-handle"
              #panelDividerTooltip="matTooltip"
              matTooltip="Change View Size"
              matTooltipPosition="above"
              matTooltipClass="design-3d-tooltip"
            >
              <i class="fa-sharp fa-light fa-arrows-from-line fa-rotate-90"></i>
            </span>
          </div>
        </div>

        <ng-template #downloadPopoverContent>
          <div class="download-popover-list">
            <button type="button" (click)="downloadPopover.hide(); downloadPDF()">Download PDF</button>
            <button type="button" (click)="downloadPopover.hide(); downloadSVG()">Download SVG</button>
          </div>
        </ng-template>

        <ng-template #twoSidedWarning>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow two-sided-modal-title">
              <h1>Add Two-sided Printing?</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal(); cancelPendingPrinting()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <p>For a better unpacking experience, upgrade your box to two-sided printing.</p>
              <p>Would you like to add two-sided printing?</p>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal(); addTwoSidePrinting()">Yes</button>
              <button type="button" class="white-submit" (click)="closeModal(); cancelPendingPrinting()">No</button>
            </div>
          </div>
        </ng-template>

        <ng-template #cancelTwoSidedWarning>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow two-sided-modal-title">
              <h1>Remove Two-sided Printing?</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal(); cancelPendingPrinting()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <p>This will remove two-sided printing and discard your inside design. This cannot be undone.</p>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal(); cancelTwoSidedPrinting()">OK</button>
              <button type="button" class="white-submit" (click)="closeModal(); cancelPendingPrinting()">CANCEL</button>
            </div>
          </div>
        </ng-template>

        <ng-template #nameDesign>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Name Your Design</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <p>Give this design a name so you can find it later:</p>
              <input
                type="text"
                class="form-control"
                aria-label="Design name"
                [(ngModel)]="designName"
                (keydown.enter)="confirmDesignName()"
              />
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="confirmDesignName()">Save</button>
              <button type="button" class="white-submit" (click)="closeModal()">Cancel</button>
            </div>
          </div>
        </ng-template>

        <ng-template #notFoundModal>
          <app-not-found-modal></app-not-found-modal>
        </ng-template>

        <ng-template #userIdle>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Psst...your session is about to expire.</h1>
            </div>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <p>
                You will be logged out in {{ idleSession.remainingSeconds() }} seconds to protect your account.
                <br />Please click "Continue" and be sure to save or you may lose your design.
              </p>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="continueSession()">Continue</button>
            </div>
          </div>
        </ng-template>

        <ng-template #clearAllWarning>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Clear All</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid">
              <p>This will remove all elements added to the design, are you sure?</p>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal(); clearAll()">Clear All</button>
              <button type="button" class="white-submit" (click)="closeModal()">Cancel</button>
            </div>
          </div>
        </ng-template>

        <ng-template #previewHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>3D Preview Controls</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="help-modal-tabs">
            <button
              type="button"
              class="help-modal-tab"
              [class.active]="previewHelpTab === 'operations'"
              (click)="previewHelpTab = 'operations'"
            >
              Common
            </button>
            <button
              type="button"
              class="help-modal-tab"
              [class.active]="previewHelpTab === 'shortcuts'"
              (click)="previewHelpTab = 'shortcuts'"
            >
              Additional
            </button>
          </div>
          <div class="modal-body">
            @if (previewHelpTab === "operations") {
              <div class="container-fluid help-container">
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-regular fa-computer-mouse-button-left"></i></span>
                      <div class="legend-modal-text">
                        <b>Mouse Click</b>
                        <p>Rotate or pan the view - depending on the tool selected</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="eyebrow-divider"></div>
              <div class="container-fluid help-container">
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <span class="legend-icon-group legend-icon-group--column">
                        <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-search-minus"></i></span>
                        <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-search-plus"></i></span>
                      </span>
                      <div class="legend-modal-text">
                        <b>Zoom Slider</b>
                        <p>Zoom in and out without using the scroll wheel or a pinch gesture</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-maximize"></i></span>
                      <div class="legend-modal-text">
                        <b>Expand Preview</b>
                        <p>Temporarily enlarge the 3D preview panel</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-minimize"></i></span>
                      <div class="legend-modal-text">
                        <b>Minimize Preview</b>
                        <p>Restore the 3D preview panel back to its normal size</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-left-right"></i></span>
                      <div class="legend-modal-text">
                        <b>Rotate</b>
                        <p>Orbit the view around the box</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-hand-paper"></i></span>
                      <div class="legend-modal-text">
                        <b>Move</b>
                        <p>Pan the view without switching tools</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-expand"></i></span>
                      <div class="legend-modal-text">
                        <b>Reset View</b>
                        <p>Snap the camera back to its default framing - appears once you've moved it</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="container-fluid help-container">
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <span class="legend-icon-placeholder"></span>
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">Shift</span>
                          <span class="key-plus">+</span>
                          <i class="fa-sharp fa-regular fa-computer-mouse-button-left" aria-hidden="true"></i>
                          <span class="visually-hidden">Left-click</span>
                          + Drag
                        </b>
                        <p>Rotate the view without switching tools - works even while Move is selected</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-placeholder"></span>
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <i class="fa-sharp fa-regular fa-computer-mouse-button-left" aria-hidden="true"></i>
                          <span class="visually-hidden">Left-click</span>
                          + Drag
                        </b>
                        <p>Pan the view without switching tools - works even while Rotate is selected</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <span class="legend-icon-placeholder"></span>
                      <div class="legend-modal-text">
                        <b>Scroll Wheel</b>
                        <p>Zoom in and out</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-placeholder"></span>
                      <div class="legend-modal-text">
                        <b>Pinch</b>
                        <p>Zoom in and out</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #backgroundHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Background Settings</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Type</b>
                      <p>Choose Solid, Linear, or Radial fill</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Color</b>
                      <p>Solid fill only - set the single fill color, click the swatch to open the picker</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>From / To</b>
                      <p>Linear/Radial fill only - set the two colors the gradient blends between</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Angle</b>
                      <p>Set the gradient direction - Linear fill only</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Opacity</b>
                      <p>Fade the background so the box material shows through</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #textHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Text Settings</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Font</b>
                      <p>Choose a font family</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Size</b>
                      <p>Set the text size</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Color</b>
                      <p>Set the text fill color</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Opacity</b>
                      <p>Fade the text</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-bold"></i></span>
                    <div class="legend-modal-text">
                      <b>Bold</b>
                      <p>Make the text bold</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-italic"></i></span>
                    <div class="legend-modal-text">
                      <b>Italic</b>
                      <p>Italicize the text</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-underline"></i></span>
                    <div class="legend-modal-text">
                      <b>Underline</b>
                      <p>Underline the text</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-strikethrough"></i></span>
                    <div class="legend-modal-text">
                      <b>Strikethrough</b>
                      <p>Draw a line through the text</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-overline"></i></span>
                    <div class="legend-modal-text">
                      <b>Overline</b>
                      <p>Draw a line above the text</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-left-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Left</b>
                      <p>Snap the text to the left edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-left-right"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Center</b>
                      <p>Center the text horizontally on the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-right-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Right</b>
                      <p>Snap the text to the right edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-up-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Top</b>
                      <p>Snap the text to the top edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-up-down"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Middle</b>
                      <p>Center the text vertically on the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-down-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Bottom</b>
                      <p>Snap the text to the bottom edge of the box panel</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Line Height</b>
                      <p>Set the space between lines</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Kerning</b>
                      <p>Set the space between letters</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-highlighter"></i></span>
                    <div class="legend-modal-text">
                      <b>Highlight</b>
                      <p>Add a color block behind the text</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Outline</b>
                      <p>Add a colored stroke around each letter</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-group legend-icon-group--column">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-align-left"></i></span>
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-align-center"></i></span>
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-align-right"></i></span>
                    </span>
                    <div class="legend-modal-text">
                      <b>Justify</b>
                      <p>Align the text left, center, or right within its own box</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #patternHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Pattern Settings</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Background</b>
                      <p>Set the color behind the pattern</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Opacity</b>
                      <p>Fade the pattern</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-left-right"></i></span>
                    <div class="legend-modal-text">
                      <b>Flip Horizontal</b>
                      <p>Mirror the pattern left to right</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-up-down"></i></span>
                    <div class="legend-modal-text">
                      <b>Flip Vertical</b>
                      <p>Mirror the pattern top to bottom</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Accent Colors</b>
                      <p>Update a library pattern's built-in accent colors, if it has any</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Style</b>
                      <p>Choose a custom pattern's shape</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Scale</b>
                      <p>Set a custom pattern's repeat size</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Accent</b>
                      <p>Recolor a custom pattern's accent shape</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Rotate Handle</b>
                      <p>Drag the handle above a whole-box custom pattern to rotate it</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #shapeHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Shape Settings</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Fill Type</b>
                      <p>Choose Solid, Linear, or Radial fill</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Fill Color</b>
                      <p>Solid fill only - set the single fill color</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Fill From / To</b>
                      <p>Linear/Radial fill only - set the two colors the gradient blends between</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Fill Angle</b>
                      <p>Set the gradient direction - Linear fill only</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Stroke</b>
                      <p>Set the outline color and width</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Opacity</b>
                      <p>Fade the shape</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-left-right"></i></span>
                    <div class="legend-modal-text">
                      <b>Flip Horizontal</b>
                      <p>Mirror the shape left to right</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-up-down"></i></span>
                    <div class="legend-modal-text">
                      <b>Flip Vertical</b>
                      <p>Mirror the shape top to bottom</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-left-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Left</b>
                      <p>Snap the shape to the left edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-left-right"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Center</b>
                      <p>Center the shape horizontally on the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-right-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Right</b>
                      <p>Snap the shape to the right edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-up-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Top</b>
                      <p>Snap the shape to the top edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-up-down"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Middle</b>
                      <p>Center the shape vertically on the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-down-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Bottom</b>
                      <p>Snap the shape to the bottom edge of the box panel</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #imageHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Image Settings</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Opacity</b>
                      <p>Fade the image</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-left-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Left</b>
                      <p>Snap the image to the left edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-left-right"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Center</b>
                      <p>Center the image horizontally on the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-right-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Right</b>
                      <p>Snap the image to the right edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-up-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Top</b>
                      <p>Snap the image to the top edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-up-down"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Middle</b>
                      <p>Center the image vertically on the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrow-down-to-line"></i></span>
                    <div class="legend-modal-text">
                      <b>Align Bottom</b>
                      <p>Snap the image to the bottom edge of the box panel</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-crop"></i></span>
                    <div class="legend-modal-text">
                      <b>Crop</b>
                      <p>Trim the image - drag the handles, then Apply or Cancel</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #designAreaHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>2D Design Area</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="help-modal-tabs">
            <button
              type="button"
              class="help-modal-tab"
              [class.active]="designAreaHelpTab === 'design'"
              (click)="designAreaHelpTab = 'design'"
            >
              Design
            </button>
            <button
              type="button"
              class="help-modal-tab"
              [class.active]="designAreaHelpTab === 'shortcuts'"
              (click)="designAreaHelpTab = 'shortcuts'"
            >
              Keyboard Shortcuts
            </button>
          </div>
          <div class="modal-body">
            @if (designAreaHelpTab === "design") {
              <div class="container-fluid help-container">
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-circle-info"></i></span>
                      <div class="legend-modal-text">
                        <b>Legend</b>
                        <p>Explains the Bleed/Crease/Cut lines drawn on the canvas</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-ruler-combined fa-rotate-90"></i></span>
                      <div class="legend-modal-text">
                        <b>Rulers</b>
                        <p>Toggle ruler guides along the top and left edges</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-border-all"></i></span>
                      <div class="legend-modal-text">
                        <b>Guides</b>
                        <p>Toggle the die-line guide overlay (bleed/crease/cut)</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-expand"></i></span>
                      <div class="legend-modal-text">
                        <b>Reset Zoom</b>
                        <p>Snap back to 100% zoom - appears once you've zoomed</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-group legend-icon-group--column">
                        <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-search-minus"></i></span>
                        <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-search-plus"></i></span>
                      </span>
                      <div class="legend-modal-text">
                        <b>Zoom</b>
                        <p>Zoom the 2D canvas in and out</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-mouse-pointer"></i></span>
                      <div class="legend-modal-text">
                        <b>Select</b>
                        <p>Select elements, once you're zoomed in</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-hand-paper"></i></span>
                      <div class="legend-modal-text">
                        <b>Move</b>
                        <p>Pan the zoomed area around instead of selecting</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-placeholder"></span>
                      <div class="legend-modal-text">
                        <b>Outside / Inside</b>
                        <p>Switch which side of the box you're designing, once two-sided printing is on</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-placeholder"></span>
                      <div class="legend-modal-text">
                        <b>Two-Sided Printing</b>
                        <p>Add or cancel a second, inside design</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-download"></i></span>
                      <div class="legend-modal-text">
                        <b>Download</b>
                        <p>Download a proof of your current design, either as a PDF or an SVG</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-from-line fa-rotate-90"></i></span>
                      <div class="legend-modal-text">
                        <b>Change View Size</b>
                        <p>Drag to resize the 2D design and 3D preview panels</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            } @else {
              <div class="container-fluid help-container">
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">Shift</span>
                          <span class="key-plus">+</span>
                          <span class="key">Arrows</span>
                        </b>
                        <p>Move the selected object</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">Arrows</span>
                        </b>
                        <p>Resize the selected object</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">Delete</span>
                        </b>
                        <p>Deletes the selected object</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">X</span>
                        </b>
                        <p>Clear all</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">D</span>
                        </b>
                        <p>Duplicate selected item</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">F</span>
                        </b>
                        <p>Bring the selected item forward</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">B</span>
                        </b>
                        <p>Send the selected item backward</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">U</span>
                        </b>
                        <p>Undo latest action</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">Shift</span>
                          <span class="key-plus">+</span>
                          <span class="key">R</span>
                        </b>
                        <p>Redo latest undone action</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col">
                  <div class="legend-modal-list">
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">R</span>
                        </b>
                        <p>Display the rulers</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">G</span>
                        </b>
                        <p>Toggle the die-line guide overlay</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">+</span>
                        </b>
                        <p>Zoom in the 2D design area</p>
                      </div>
                    </div>
                    <div class="legend-modal-item">
                      <div class="legend-modal-text">
                        <b>
                          <span class="key">{{ modifierKeyLabel }}</span>
                          <span class="key-plus">+</span>
                          <span class="key">-</span>
                        </b>
                        <p>Zoom out the 2D design area</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #aiCategoryHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>AI Design</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <p class="help-modal-intro">
              Elements the AI adds work like anything else in the 2D designer - select one to move, resize, recolor, or delete it.
            </p>
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Prompt</b>
                      <p>Describe the design you want in your own words, e.g. "make a blue box with white snowflakes"</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-paper-plane"></i></span>
                    <div class="legend-modal-text">
                      <b>Send</b>
                      <p>Generate artwork from your prompt and add it to the box</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-arrows-rotate"></i></span>
                    <div class="legend-modal-text">
                      <b>Start New Chat</b>
                      <p>Clear the conversation and start over with a fresh prompt</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Reference IDs</b>
                      <p>Each new element gets a short reference ID in brackets, e.g. [a1] - name it in a later prompt
                        to edit or remove that specific element</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Panel Names</b>
                      <p>You can reference parts of the structure like <code>inside</code> or <code>top</code>,
                        or you can name specific panels by the name that shows when you hover over them</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #drawCategoryHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Draw &amp; Fill</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <p class="help-modal-intro">
              Once you've added an element has been added to the design you can update the color.
              For the fill tool you can also update the type of fill after adding it.
            </p>
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-pencil"></i></span>
                    <div class="legend-modal-text">
                      <b>Pencil</b>
                      <p>Draw thin freehand lines</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-marker"></i></span>
                    <div class="legend-modal-text">
                      <b>Marker</b>
                      <p>Draw thicker freehand strokes</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-spray-can"></i></span>
                    <div class="legend-modal-text">
                      <b>Spray</b>
                      <p>Draw a soft, spray-paint style stroke</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-sharp fa-light fa-fill-drip"></i></span>
                    <div class="legend-modal-text">
                      <b>Fill</b>
                      <p>Fill an enclosed area with a color or gradient</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Type</b>
                      <p>Fill tool only - choose Solid, Linear, or Radial fill</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>From / To</b>
                      <p>Fill tool, Linear/Radial fill only - set the two colors the gradient blends between</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Color</b>
                      <p>Set the color of the active tool - hidden while Fill is active</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Width</b>
                      <p>Set the brush stroke width - hidden while Fill is active</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #patternsCategoryHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Patterns</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <p class="help-modal-intro">
              After adding a pattern the background color and each accent color can be adjusted.
            </p>
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Library</b>
                      <p>Browse ready-made patterns, grouped by collection</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Pattern Thumbnail</b>
                      <p>Click a pattern to add it to the box</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>View Entire Library</b>
                      <p>Browse the full pattern library in a larger view</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Custom</b>
                      <p>Build your own repeating pattern from a shape and accent color</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Add to Whole Box</b>
                      <p>Apply a custom pattern across every panel - Custom tab only</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Add to a Panel</b>
                      <p>Click a single panel to apply a custom pattern to just that panel - Custom tab only</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #shapesCategoryHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Shapes</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <p class="help-modal-intro">After adding a shape to the design the fill color, outline, and more can be adjusted.</p>
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Shape Thumbnail</b>
                      <p>Click a shape to add it to the box</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>View Entire Library</b>
                      <p>Browse the full shape library in a larger view</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #imagesCategoryHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Images</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa fa-image"></i></span>
                    <div class="legend-modal-text">
                      <b>Upload Image</b>
                      <p>Add an image from your device</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-swatch"><i class="fa-kit fa-pixabay-camera"></i></span>
                    <div class="legend-modal-text">
                      <b>Add Pixabay</b>
                      <p>Search and add a free stock photo from Pixabay</p>
                    </div>
                  </div>
                  @if (aiImageGenerationEnabled) {
                    <div class="legend-modal-item">
                      <span class="legend-icon-swatch"><i class="fa fa-sparkles"></i></span>
                      <div class="legend-modal-text">
                        <b>AI Generate</b>
                        <p>Generate an image from a text prompt</p>
                      </div>
                    </div>
                  }
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Your Uploaded Images</b>
                      <p>Click a previously uploaded image to add it again</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        <ng-template #materialCategoryHelp>
          <div class="modal-header pb-0 border-0">
            <div class="modal-title page-title eyebrow">
              <h1>Material &amp; Finish</h1>
            </div>
            <button type="button" class="close-button pull-right" (click)="closeModal()">
              <img src="assets/cb/images/close-icon.png" alt="Close" />
            </button>
          </div>
          <div class="modal-body">
            <div class="container-fluid help-container">
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Printing</b>
                      <p>Choose how the box is printed, e.g. 2-sided print, inside only, or outside only</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Outer Material</b>
                      <p>Choose the outer board or material</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col">
                <div class="legend-modal-list">
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Inner Material</b>
                      <p>Choose the inner liner material</p>
                    </div>
                  </div>
                  <div class="legend-modal-item">
                    <span class="legend-icon-placeholder"></span>
                    <div class="legend-modal-text">
                      <b>Finish</b>
                      <p>Choose a coating or finish for the outer material</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <button type="button" class="white-submit" (click)="closeModal()">OK</button>
            </div>
          </div>
        </ng-template>

        @if (downloadUrl) {
          <iframe [src]="downloadUrl" style="border: none" width="1" height="1"></iframe>
        }

        <div
          class="design-3d-column"
          [class.design-3d-column--dragging]="isDraggingDivider"
          [style.flex-basis.cqw]="100 - splitRatio"
        >
          <div
            [class.tour-highlight]="helpSection === 'customBoxExplanation'"
            [popover]="customBoxExplanationContent"
            [isOpen]="helpSection === 'customBoxExplanation'"
            placement="left"
            container="body"
            triggers=""
          >
          @if (!selectedElementType) {
            <div class="design-3d-toolbar">
              <h2 class="design-3d-toolbar-header design-3d-toolbar-header--with-help">
                Background Settings
                <button type="button" class="design-3d-help-link" (click)="showBackgroundHelp()">
                  <i class="fa-sharp fa-light fa-circle-question"></i>
                  <span>Help</span>
                </button>
              </h2>
              <app-gradient-picker [value]="canvasBackgroundFill" ariaLabel="Background color" (valueChange)="setCanvasBackgroundFill($event)" />
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Opacity</span>
                <mat-slider
                  class="design-3d-slider"
                  discrete
                  [displayWith]="opacityDisplayWith"
                  min="0"
                  max="1"
                  step="0.01"
                  matTooltip="Background opacity"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <input
                    matSliderThumb
                    aria-label="Background opacity"
                    [ngModel]="canvasBackgroundOpacity"
                    (ngModelChange)="setCanvasBackgroundOpacity($event)"
                    (pointerup)="blurSliderThumb($event)"
                  />
                </mat-slider>
              </div>
            </div>
          }
          @if (selectedElementType === "text") {
            <div class="design-3d-toolbar">
              <h2 class="design-3d-toolbar-header design-3d-toolbar-header--with-help">
                Text Settings
                <button type="button" class="design-3d-help-link" (click)="showTextHelp()">
                  <i class="fa-sharp fa-light fa-circle-question"></i>
                  <span>Help</span>
                </button>
              </h2>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Font</span>
                <mat-select
                  class="element-toolbar-select element-toolbar-select--font"
                  panelClass="element-toolbar-select-panel element-toolbar-select-panel--font"
                  [panelWidth]="null"
                  aria-label="Font"
                  disableOptionCentering="true"
                  [ngModel]="textFontFamily"
                  (ngModelChange)="setTextFontFamily($event)"
                  matTooltip="Font"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  @for (group of fontGroups; track group.label) {
                    <mat-optgroup [label]="group.label">
                      @for (font of group.fonts; track font.name) {
                        <mat-option [value]="font.name" [style.fontFamily]="font.name">{{ font.name }}</mat-option>
                      }
                    </mat-optgroup>
                  }
                </mat-select>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Size</span>
                <mat-select
                  class="element-toolbar-select element-toolbar-select--narrow"
                  panelClass="element-toolbar-select-panel"
                  [panelWidth]="null"
                  aria-label="Size"
                  disableOptionCentering="true"
                  [ngModel]="textFontSize"
                  (ngModelChange)="setTextFontSize($event)"
                  matTooltip="Font size"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  @for (size of fontSizeOptions; track size) {
                    <mat-option [value]="size">{{ size }}</mat-option>
                  }
                </mat-select>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Color</span>
                <app-color-picker
                  [hex]="textColor"
                  [cmyk]="textColorCmyk"
                  ariaLabel="Text color"
                  (colorChange)="setTextColor($event)"
                />
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Opacity</span>
                <mat-slider
                  class="design-3d-slider"
                  discrete
                  [displayWith]="opacityDisplayWith"
                  min="0"
                  max="1"
                  step="0.01"
                  matTooltip="Text opacity"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <input
                    matSliderThumb
                    aria-label="Text opacity"
                    [ngModel]="elementOpacity"
                    (ngModelChange)="setElementOpacity($event)"
                    (pointerup)="blurSliderThumb($event)"
                  />
                </mat-slider>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Style</span>
                <div class="element-toolbar-btn-group">
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="textBold"
                    [disabled]="!fontSupportsBold(textFontFamily)"
                    (click)="toggleTextBold()"
                    aria-label="Bold"
                    [matTooltip]="fontSupportsBold(textFontFamily) ? 'Bold' : 'Bold is not available for this font'"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-bold"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="textItalic"
                    [disabled]="!fontSupportsItalic(textFontFamily)"
                    (click)="toggleTextItalic()"
                    aria-label="Italic"
                    [matTooltip]="fontSupportsItalic(textFontFamily) ? 'Italic' : 'Italic is not available for this font'"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-italic"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="textUnderline"
                    (click)="toggleTextUnderline()"
                    aria-label="Underline"
                    matTooltip="Underline"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-underline"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="textStrikethrough"
                    (click)="toggleTextStrikethrough()"
                    aria-label="Strikethrough"
                    matTooltip="Strikethrough"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-strikethrough"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="textOverline"
                    (click)="toggleTextOverline()"
                    aria-label="Overline"
                    matTooltip="Overline"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-overline"></i>
                  </button>
                </div>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Line Height</span>
                <input
                  type="number"
                  class="element-toolbar-number element-toolbar-number--no-spinner"
                  min="0.5"
                  max="3"
                  step="0.05"
                  [ngModel]="textLineHeight"
                  (ngModelChange)="setTextLineHeight($event)"
                  matTooltip="Line height"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                />
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Kerning</span>
                <input
                  type="number"
                  class="element-toolbar-number element-toolbar-number--no-spinner"
                  min="-200"
                  max="800"
                  step="10"
                  [ngModel]="textCharSpacing"
                  (ngModelChange)="setTextCharSpacing($event)"
                  matTooltip="Kerning (letter spacing)"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                />
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Highlight</span>
                <div class="element-toolbar-row">
                  <app-color-picker
                    [hex]="textBackgroundColor"
                    [cmyk]="textBackgroundColorCmyk"
                    ariaLabel="Highlight color"
                    (colorChange)="setTextBackgroundColor($event)"
                  />
                  <button
                    type="button"
                    class="element-toolbar-btn element-toolbar-btn--bordered"
                    [class.active]="textHighlightEnabled"
                    (click)="toggleTextHighlight()"
                    aria-label="Toggle highlight"
                    matTooltip="Toggle highlight"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-highlighter"></i>
                  </button>
                </div>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Outline</span>
                <div class="element-toolbar-row">
                  <app-color-picker
                    [hex]="textStrokeColor"
                    [cmyk]="textStrokeColorCmyk"
                    ariaLabel="Outline color"
                    (colorChange)="setTextStrokeColor($event)"
                  />
                  <mat-select
                    class="element-toolbar-select element-toolbar-select--narrow"
                    panelClass="element-toolbar-select-panel"
                    [panelWidth]="null"
                    aria-label="Outline width"
                    disableOptionCentering="true"
                    [ngModel]="textStrokeWidth"
                    (ngModelChange)="setTextStrokeWidth($event)"
                    matTooltip="Outline width"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    @for (width of strokeWidthOptions; track width) {
                      <mat-option [value]="width">{{ width }}</mat-option>
                    }
                  </mat-select>
                </div>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Justify</span>
                <div class="element-toolbar-btn-group">
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="textJustify === 'left'"
                    (click)="setTextJustify('left')"
                    aria-label="Justify left"
                    matTooltip="Justify left"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-align-left"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="textJustify === 'center'"
                    (click)="setTextJustify('center')"
                    aria-label="Justify center"
                    matTooltip="Justify center"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-align-center"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="textJustify === 'right'"
                    (click)="setTextJustify('right')"
                    aria-label="Justify right"
                    matTooltip="Justify right"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-align-right"></i>
                  </button>
                </div>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Align on Panel</span>
                <div class="element-toolbar-btn-group">
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('left')"
                    aria-label="Align left"
                    matTooltip="Align left"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrow-left-to-line"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('centerX')"
                    aria-label="Align center"
                    matTooltip="Align center"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrows-left-right"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('right')"
                    aria-label="Align right"
                    matTooltip="Align right"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrow-right-to-line"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('top')"
                    aria-label="Align top"
                    matTooltip="Align top"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrow-up-to-line"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('centerY')"
                    aria-label="Align middle"
                    matTooltip="Align middle"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrows-up-down"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('bottom')"
                    aria-label="Align bottom"
                    matTooltip="Align bottom"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrow-down-to-line"></i>
                  </button>
                </div>
              </div>
            </div>
          }
          @if (selectedElementType === "pattern") {
            <div class="design-3d-toolbar">
              <h2 class="design-3d-toolbar-header design-3d-toolbar-header--with-help">
                Pattern Settings
                <button type="button" class="design-3d-help-link" (click)="showPatternHelp()">
                  <i class="fa-sharp fa-light fa-circle-question"></i>
                  <span>Help</span>
                </button>
              </h2>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Background</span>
                <app-color-picker
                  [hex]="patternBackgroundColor"
                  [cmyk]="patternBackgroundColorCmyk"
                  ariaLabel="Pattern background color"
                  (colorChange)="setPatternBackgroundColor($event)"
                />
              </div>
              @if (patternAccentColors.length > 0) {
                <div class="element-toolbar-group">
                  <span class="element-toolbar-label">Accent Colors</span>
                  <div class="element-toolbar-row">
                    @for (color of patternAccentColors; track $index) {
                      <app-color-picker
                        [hex]="color"
                        [cmyk]="patternAccentColorsCmyk[$index]"
                        [ariaLabel]="'Accent ' + ($index + 1)"
                        (colorChange)="setPatternAccentColor($index, $event)"
                      />
                    }
                  </div>
                </div>
              }
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Opacity</span>
                <mat-slider
                  class="design-3d-slider"
                  discrete
                  [displayWith]="opacityDisplayWith"
                  min="0"
                  max="1"
                  step="0.01"
                  matTooltip="Pattern opacity"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <input
                    matSliderThumb
                    aria-label="Pattern opacity"
                    [ngModel]="elementOpacity"
                    (ngModelChange)="setElementOpacity($event)"
                    (pointerup)="blurSliderThumb($event)"
                  />
                </mat-slider>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Flip</span>
                <div class="element-toolbar-btn-group">
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="patternFlipX"
                    (click)="togglePatternFlipX()"
                    aria-label="Flip horizontal"
                    matTooltip="Flip horizontal"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrows-left-right"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="patternFlipY"
                    (click)="togglePatternFlipY()"
                    aria-label="Flip vertical"
                    matTooltip="Flip vertical"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrows-up-down"></i>
                  </button>
                </div>
              </div>
            </div>
          }
          @if (selectedElementType === "geometricPattern") {
            <div class="design-3d-toolbar">
              <h2 class="design-3d-toolbar-header design-3d-toolbar-header--with-help">
                Custom Pattern Settings
                <button type="button" class="design-3d-help-link" (click)="showPatternHelp()">
                  <i class="fa-sharp fa-light fa-circle-question"></i>
                  <span>Help</span>
                </button>
              </h2>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Style</span>
                <mat-select
                  class="element-toolbar-select element-toolbar-select--style"
                  panelClass="element-toolbar-select-panel"
                  [panelWidth]="null"
                  aria-label="Pattern style"
                  disableOptionCentering="true"
                  [ngModel]="geometricPatternStyle"
                  (ngModelChange)="setGeometricPatternStyle($event)"
                >
                  @for (style of geometricPatternStyleOptions; track style.value) {
                    <mat-option [value]="style.value">{{ style.label }}</mat-option>
                  }
                </mat-select>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Background</span>
                <app-color-picker
                  [hex]="geometricPatternBackgroundColor"
                  [cmyk]="geometricPatternBackgroundColorCmyk"
                  ariaLabel="Pattern background color"
                  (colorChange)="setGeometricPatternBackgroundColor($event)"
                />
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Accent</span>
                <app-color-picker
                  [hex]="geometricPatternAccentColors[0]"
                  [cmyk]="geometricPatternAccentColorsCmyk[0]"
                  ariaLabel="Pattern accent color"
                  (colorChange)="setGeometricPatternAccentColor($event)"
                />
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Scale</span>
                <mat-slider class="design-3d-slider" discrete min="0.02" max="0.5" step="0.01" matTooltip="Repeat size" matTooltipPosition="above">
                  <input
                    matSliderThumb
                    aria-label="Repeat size"
                    [ngModel]="geometricPatternScale"
                    (ngModelChange)="setGeometricPatternScale($event)"
                    (pointerup)="blurSliderThumb($event)"
                  />
                </mat-slider>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Opacity</span>
                <mat-slider
                  class="design-3d-slider"
                  discrete
                  [displayWith]="opacityDisplayWith"
                  min="0"
                  max="1"
                  step="0.01"
                  matTooltip="Pattern opacity"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <input
                    matSliderThumb
                    aria-label="Pattern opacity"
                    [ngModel]="elementOpacity"
                    (ngModelChange)="setElementOpacity($event)"
                    (pointerup)="blurSliderThumb($event)"
                  />
                </mat-slider>
              </div>
            </div>
          }
          @if (selectedElementType === "shape") {
            <div class="design-3d-toolbar">
              <h2 class="design-3d-toolbar-header design-3d-toolbar-header--with-help">
                Shape Settings
                <button type="button" class="design-3d-help-link" (click)="showShapeHelp()">
                  <i class="fa-sharp fa-light fa-circle-question"></i>
                  <span>Help</span>
                </button>
              </h2>
              <app-gradient-picker [value]="shapeFill" ariaLabel="Shape fill color" (valueChange)="setShapeFill($event)" />
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Opacity</span>
                <mat-slider
                  class="design-3d-slider"
                  discrete
                  [displayWith]="opacityDisplayWith"
                  min="0"
                  max="1"
                  step="0.01"
                  matTooltip="Shape opacity"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <input
                    matSliderThumb
                    aria-label="Shape opacity"
                    [ngModel]="elementOpacity"
                    (ngModelChange)="setElementOpacity($event)"
                    (pointerup)="blurSliderThumb($event)"
                  />
                </mat-slider>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Stroke</span>
                <div class="element-toolbar-row">
                  <app-color-picker
                    [hex]="shapeStrokeColor"
                    [cmyk]="shapeStrokeColorCmyk"
                    ariaLabel="Shape stroke color"
                    (colorChange)="setShapeStrokeColor($event)"
                  />
                  <mat-select
                    class="element-toolbar-select element-toolbar-select--narrow"
                    panelClass="element-toolbar-select-panel"
                    [panelWidth]="null"
                    aria-label="Stroke width"
                    disableOptionCentering="true"
                    [ngModel]="shapeStrokeWidth"
                    (ngModelChange)="setShapeStrokeWidth($event)"
                    matTooltip="Stroke width"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    @for (width of strokeWidthOptions; track width) {
                      <mat-option [value]="width">{{ width }}</mat-option>
                    }
                  </mat-select>
                </div>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Flip</span>
                <div class="element-toolbar-btn-group">
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="shapeFlipX"
                    (click)="toggleShapeFlipX()"
                    aria-label="Flip horizontal"
                    matTooltip="Flip horizontal"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrows-left-right"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    [class.active]="shapeFlipY"
                    (click)="toggleShapeFlipY()"
                    aria-label="Flip vertical"
                    matTooltip="Flip vertical"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrows-up-down"></i>
                  </button>
                </div>
              </div>
              <div class="element-toolbar-group">
                <span class="element-toolbar-label">Align on Panel</span>
                <div class="element-toolbar-btn-group">
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('left')"
                    aria-label="Align left"
                    matTooltip="Align left"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrow-left-to-line"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('centerX')"
                    aria-label="Align center"
                    matTooltip="Align center"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrows-left-right"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('right')"
                    aria-label="Align right"
                    matTooltip="Align right"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrow-right-to-line"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('top')"
                    aria-label="Align top"
                    matTooltip="Align top"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrow-up-to-line"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('centerY')"
                    aria-label="Align middle"
                    matTooltip="Align middle"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrows-up-down"></i>
                  </button>
                  <button
                    type="button"
                    class="element-toolbar-btn"
                    (click)="alignElementOnFace('bottom')"
                    aria-label="Align bottom"
                    matTooltip="Align bottom"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrow-down-to-line"></i>
                  </button>
                </div>
              </div>
            </div>
          }
          @if (selectedElementType === "image") {
            <div class="design-3d-toolbar">
              <h2 class="design-3d-toolbar-header design-3d-toolbar-header--with-help">
                Image Settings
                <button type="button" class="design-3d-help-link" (click)="showImageHelp()">
                  <i class="fa-sharp fa-light fa-circle-question"></i>
                  <span>Help</span>
                </button>
              </h2>
              @if (!cropModeActive) {
                <div class="element-toolbar-group">
                  <span class="element-toolbar-label">Opacity</span>
                  <mat-slider
                    class="design-3d-slider"
                    discrete
                    [displayWith]="opacityDisplayWith"
                    min="0"
                    max="1"
                    step="0.01"
                    matTooltip="Image opacity"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <input
                      matSliderThumb
                      aria-label="Image opacity"
                      [ngModel]="elementOpacity"
                      (ngModelChange)="setElementOpacity($event)"
                      (pointerup)="blurSliderThumb($event)"
                    />
                  </mat-slider>
                </div>
                <div class="element-toolbar-group">
                  <span class="element-toolbar-label">Align on Panel</span>
                  <div class="element-toolbar-btn-group">
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      (click)="alignElementOnFace('left')"
                      aria-label="Align left"
                      matTooltip="Align left"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <i class="fa-sharp fa-light fa-arrow-left-to-line"></i>
                    </button>
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      (click)="alignElementOnFace('centerX')"
                      aria-label="Align center"
                      matTooltip="Align center"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <i class="fa-sharp fa-light fa-arrows-left-right"></i>
                    </button>
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      (click)="alignElementOnFace('right')"
                      aria-label="Align right"
                      matTooltip="Align right"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <i class="fa-sharp fa-light fa-arrow-right-to-line"></i>
                    </button>
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      (click)="alignElementOnFace('top')"
                      aria-label="Align top"
                      matTooltip="Align top"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <i class="fa-sharp fa-light fa-arrow-up-to-line"></i>
                    </button>
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      (click)="alignElementOnFace('centerY')"
                      aria-label="Align middle"
                      matTooltip="Align middle"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <i class="fa-sharp fa-light fa-arrows-up-down"></i>
                    </button>
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      (click)="alignElementOnFace('bottom')"
                      aria-label="Align bottom"
                      matTooltip="Align bottom"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <i class="fa-sharp fa-light fa-arrow-down-to-line"></i>
                    </button>
                  </div>
                </div>
                <div class="element-toolbar-group">
                  <span class="element-toolbar-label">Crop</span>
                  <button
                    type="button"
                    class="element-toolbar-btn element-toolbar-btn--bordered"
                    (click)="startImageCrop()"
                    aria-label="Crop image"
                    matTooltip="Crop image"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-crop"></i>
                  </button>
                </div>
              } @else {
                <div class="element-toolbar-group">
                  <span class="element-toolbar-label">Drag the handles, then apply or cancel.</span>
                </div>
                <div class="element-toolbar-group">
                  <div class="element-toolbar-btn-group">
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      (click)="applyImageCrop()"
                      aria-label="Apply crop"
                      matTooltip="Apply crop"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <i class="fa-sharp fa-light fa-check"></i>
                    </button>
                    <button
                      type="button"
                      class="element-toolbar-btn"
                      (click)="cancelImageCrop()"
                      aria-label="Cancel crop"
                      matTooltip="Cancel crop"
                      matTooltipPosition="above"
                      matTooltipClass="design-3d-tooltip"
                    >
                      <i class="fa-sharp fa-light fa-times"></i>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
          </div>
          <div class="design-3d-toolbar design-3d-toolbar--no-border">
            <h2 class="design-3d-toolbar-header design-3d-toolbar-header--with-help">
              Preview
              <button type="button" class="design-3d-help-link" (click)="showPreviewHelp()">
                <i class="fa-sharp fa-light fa-circle-question"></i>
                <span>Help</span>
              </button>
            </h2>
          </div>
          <div
            class="design-3d-panel"
            [class.tour-highlight]="helpSection === 'viewerExplanation'"
            [popover]="viewerExplanationContent"
            [isOpen]="helpSection === 'viewerExplanation'"
            placement="left"
            container="body"
            triggers=""
          >
            @if (loading) {
              <div class="design-3d-status">Loading 3D preview&hellip;</div>
            }
            @if (!loading && !valid) {
              <div class="design-3d-status design-3d-status--error">Could not load a 3D preview for this box.</div>
            }
            <div class="design-3d-canvas" [class.design-3d-canvas--hidden]="loading || !valid" #container></div>
            @if (!loading && valid) {
              <button
                type="button"
                class="canvas-corner-button design-3d-expand-preview"
                [class.design-3d-expand-preview--expanded]="splitRatio !== SPLIT_DEFAULT"
                (click)="togglePreviewExpand()"
                [attr.aria-label]="splitRatio === SPLIT_DEFAULT ? 'Expand preview' : 'Reset panel sizes'"
                [matTooltip]="splitRatio === SPLIT_DEFAULT ? 'Expand preview' : 'Reset panel sizes'"
                matTooltipPosition="above"
                matTooltipClass="design-3d-tooltip"
              >
                <i class="fa-sharp fa-light fa-arrows-maximize design-3d-expand-preview-icon design-3d-expand-preview-icon--expand"></i>
                <i class="fa-sharp fa-light fa-arrows-minimize design-3d-expand-preview-icon design-3d-expand-preview-icon--compress"></i>
              </button>
            }
            @if (!loading && valid) {
              <div class="design-3d-top-right-tools">
                @if (viewChanged) {
                  <button
                    type="button"
                    class="canvas-corner-button"
                    (click)="resetView()"
                    aria-label="Reset view"
                    matTooltip="Reset view"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-expand"></i>
                  </button>
                }
                <div class="design-3d-viewer-tools">
                  <button
                    type="button"
                    class="canvas-corner-button"
                    [class.active]="viewerTool === 'rotate'"
                    (click)="setViewerTool('rotate')"
                    aria-label="Rotate the view angle"
                    matTooltip="Rotate the view angle"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-arrows-left-right"></i>
                  </button>
                  <button
                    type="button"
                    class="canvas-corner-button"
                    [class.active]="viewerTool === 'pan'"
                    (click)="setViewerTool('pan')"
                    aria-label="Move the element in the view"
                    matTooltip="Move the element in the view"
                    matTooltipPosition="above"
                    matTooltipClass="design-3d-tooltip"
                  >
                    <i class="fa-sharp fa-light fa-hand-paper"></i>
                  </button>
                </div>
              </div>
              <div class="design-3d-zoom-slider">
                <button
                  type="button"
                  class="design-3d-zoom-slider-btn"
                  [disabled]="cameraZoomPercent <= 0"
                  (click)="stepCameraZoom(-1)"
                  aria-label="Zoom out"
                  matTooltip="Zoom out"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <i class="fa-sharp fa-light fa-search-minus" aria-hidden="true"></i>
                </button>
                <mat-slider
                  class="design-3d-slider design-3d-zoom-mat-slider"
                  min="0"
                  max="100"
                  step="0.1"
                  matTooltip="Camera zoom"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <input
                    matSliderThumb
                    [value]="cameraZoomPercent"
                    (valueChange)="onZoomSliderInput($event)"
                    (pointerup)="blurSliderThumb($event)"
                    aria-label="Zoom"
                  />
                </mat-slider>
                <button
                  type="button"
                  class="design-3d-zoom-slider-btn"
                  [disabled]="cameraZoomPercent >= 100"
                  (click)="stepCameraZoom(1)"
                  aria-label="Zoom in"
                  matTooltip="Zoom in"
                  matTooltipPosition="above"
                  matTooltipClass="design-3d-tooltip"
                >
                  <i class="fa-sharp fa-light fa-search-plus" aria-hidden="true"></i>
                </button>
              </div>
            }
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #shapeLibrary>
  <app-shape-library
    [shapes]="shapes"
    [shapeCollections]="shapeCollections"
    (shapeSelected)="addShape($event); closeModal()"
    (hideModal)="closeModal()"
    (loadMore)="loadMoreShapes()"
  ></app-shape-library>
</ng-template>

<ng-template #patternLibrary>
  <app-pattern-library
    [patterns]="patterns"
    [patternCollections]="patternCollections"
    (patternSelected)="addPattern($event); closeModal()"
    (hideModal)="closeModal()"
    (loadMore)="loadMorePatterns()"
  ></app-pattern-library>
</ng-template>

<ng-template #uploadImage>
  <app-image-upload
    [containerID]="containerID"
    [user]="user"
    (imageAdded)="getImages(); closeModal()"
    (hideModal)="closeModal()"
  ></app-image-upload>
</ng-template>

<ng-template #uploadPixabay>
  <app-pixabay-modal
    [containerId]="containerID"
    [user]="user"
    (pixabayAdded)="getImages(); closeModal()"
  ></app-pixabay-modal>
</ng-template>

<ng-template #aiImageGenerate>
  <app-ai-image-modal
    [containerId]="containerID"
    [user]="user"
    (imageCreated)="getImages()"
    (imageGenerated)="addGeneratedImage($event); closeModal()"
    (hideModal)="closeModal()"
  ></app-ai-image-modal>
</ng-template>

<ng-template #tutorialVideo>
  <div class="tutorial-video-modal">
    <iframe
      width="1100"
      height="600"
      src="https://www.youtube.com/embed/2gCGo-i0RpU"
      frameborder="0"
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
      allowfullscreen
    ></iframe>
  </div>
</ng-template>

@if (helpView) {
  <div class="tour-background" (click)="hideTour()"></div>
}

<ng-template #elementExplanationContent>
  <p>Add elements like backgrounds, images, and text to your design.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="hideTour()" class="tour-exit">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">NEXT</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>

<ng-template #patternExplanationContent>
  <p>Search, browse, or open the full gallery of options for each design element.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="hideTour()" class="tour-exit">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">NEXT</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>

<ng-template #toolbarExplanationContent>
  <p>Set of global tools that help duplicate, move, undo, redo, delete, even start over.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="hideTour()" class="tour-exit">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">NEXT</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>

<ng-template #rulerExplanationContent>
  <p>Toggle the rulers or the guide to help you position your graphics.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="hideTour()" class="tour-exit">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">NEXT</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>

<ng-template #zoomExplanationContent>
  <p>Zoom in and out to check the fine details of your design.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="hideTour()" class="tour-exit">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">NEXT</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>

<ng-template #designAreaExplanationContent>
  <p>2D design area. Your added elements will display here to be edited.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="hideTour()" class="tour-exit">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">NEXT</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>

<ng-template #customBoxExplanationContent>
  <p>Tools specific to your design element will display here to edit each item.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="hideTour()" class="tour-exit">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">NEXT</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>

<ng-template #viewerExplanationContent>
  <p>Interactive 3D viewer to display your design in real-time.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="hideTour()" class="tour-exit">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">NEXT</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>

<ng-template #twoSidedExplanationContent>
  <p>Switch between your outside and inside design views, if two-sided design has been added.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="hideTour()" class="tour-exit">EXIT TOUR</a><span class="tour-shortcut">(X)</span></span>
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">NEXT</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>

<ng-template #addToCartExplanationContent>
  <p>When your design is completed, add it to the cart.</p>
  <div class="tour-options">
    <span class="tour-option"><a (click)="advanceTour()" class="tour-continue">FINISH TOUR</a><span class="tour-shortcut">(→)</span></span>
  </div>
</ng-template>
